"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StereoImageFrame = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@openhps/core");
const ImageFrame_1 = require("./ImageFrame");
let StereoImageFrame = class StereoImageFrame extends core_1.DataFrame {
    /**
     * Source object clone that captured the data frame
     * @returns {StereoCameraObject} Source data object
     */
    get source() {
        return super.source;
    }
    /**
     * Set the source object clone that captured the data frame
     * @param {StereoCameraObject} object Source data object
     */
    set source(object) {
        super.source = object;
    }
};
exports.StereoImageFrame = StereoImageFrame;
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", ImageFrame_1.ImageFrame)
], StereoImageFrame.prototype, "left", void 0);
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", ImageFrame_1.ImageFrame)
], StereoImageFrame.prototype, "right", void 0);
exports.StereoImageFrame = StereoImageFrame = tslib_1.__decorate([
    (0, core_1.SerializableObject)()
], StereoImageFrame);
//# sourceMappingURL=StereoImageFrame.js.map